import Agent from '../agent'
import { APP_NAME } from '../agent/typing'
import { wxReadyOnly } from '../knb/knb-use'
import { swanReady } from '../3rd-lib/swan'
import { getStatisticQuery } from '../query'
import { toUrlParams } from '../base/url'
import { reportWarn } from '../owl'
import { MP_PATH_MAP } from './mp-const'

function processPath(path: string, options: { hideShareMenu?: boolean }) {
  const query: { phx_wake_up_type?: string; phx_wake_up_source?: string } = getStatisticQuery()
  const mpQueryStr = toUrlParams({
    t: query.phx_wake_up_type,
    s: query.phx_wake_up_source,
  })
  if (mpQueryStr) path += (path.indexOf('?') !== -1 ? '&' : '?') + mpQueryStr
  if (!options) return path
  if (options.hideShareMenu && Agent.appnm === APP_NAME.phoenix_wxapp) {
    path += (path.indexOf('?') !== -1 ? '&' : '?') + 'hideShareMenu=1'
  }
  return path
}

function onJumpFail(res: { errMsg?: string }, path: string) {
  reportWarn({
    name: res && res.errMsg ? res.errMsg : '小程序跳转失败',
    msg: path + JSON.stringify(res),
  })
  window.$toasted.show('Oops，跳转失败，请稍后重试')
}

export function mpNavigateTo(mpPathMap: MP_PATH_MAP, options = {}): void {
  // 默认当成美团民宿小程序
  const path = processPath(mpPathMap[Agent.appnm] || mpPathMap.phoenix_wxapp, options)
  console.log('[mppath]', path)
  if (Agent.swan) {
    swanReady(() => {
      window.swan.webView.navigateTo({
        url: path,
      })
    })
  } else {
    wxReadyOnly(() => {
      console.log('[debug]', path)
      window.wx.miniProgram.navigateTo({
        url: path,
        success(res: any) {
          console.log('[navsuccess]', res)
        },
        fail(res: { errMsg?: string }) {
          onJumpFail(res, path)
        },
      })
    })
  }
}

export function mpRedirectTo(mpPathMap: MP_PATH_MAP, options = {}): void {
  // 默认当成美团民宿小程序
  const path = processPath(mpPathMap[Agent.appnm] || mpPathMap.phoenix_wxapp, options)
  console.log('[mppath]', path)
  if (Agent.swan) {
    swanReady(() => {
      window.swan.webView.redirectTo({
        url: path,
      })
    })
  } else {
    wxReadyOnly(() => {
      window.wx.miniProgram.redirectTo({
        url: path,
        success(res: any) {
          console.log('[navsuccess]', res)
        },
        fail(res: { errMsg?: string }) {
          onJumpFail(res, path)
        },
      })
    })
  }
}

export function mpNavigateBack(): void {
  if (Agent.swan) {
    swanReady(() => {
      window.swan.webView.navigateBack()
    })
  } else {
    wxReadyOnly(() => {
      window.wx.miniProgram.navigateBack()
    })
  }
}

export function mpSwitchTab(mpPathMap: MP_PATH_MAP): void {
  // 默认当成美团民宿小程序
  const path = mpPathMap[Agent.appnm] || mpPathMap.phoenix_wxapp
  console.log('[mppath]', path)
  if (Agent.swan) {
    swanReady(() => {
      window.swan.webView.switchTab({
        url: path,
      })
    })
  } else {
    wxReadyOnly(() => {
      window.wx.miniProgram.switchTab({
        url: path,
      })
    })
  }
}
